export const VALIDATE_PASSWORD_COMPLETE = 'VALIDATE_PASSWORD_COMPLETE';

export const VALIDATE_PASSWORD_PENDING = 'VALIDATE_PASSWORD_PENDING';

export const VALIDATE_PASSWORD_ERROR = 'VALIDATE_PASSWORD_ERROR';

export const HASH_NOT_VALID = 'HASH_NOT_VALID';

export const PASSWORD_CHANGED = 'PASSWORD_CHANGED';

export type ResetPasswordReducerState = {
  passwordValidateIsCompleted: boolean;
  passwordValidateIsPending: boolean;
  passwordValidateIsError: null | boolean;
  hashNotValid: boolean;
  passwordChanged: boolean;
};

export type ResetPasswordActions =
  | { type: 'VALIDATE_PASSWORD_COMPLETE' }
  | { type: 'VALIDATE_PASSWORD_PENDING' }
  | { type: 'VALIDATE_PASSWORD_ERROR'; error: unknown }
  | { type: 'HASH_NOT_VALID' }
  | { type: 'PASSWORD_CHANGED' };
